var exports = {
  "tp": "FeatureComparisonTable.module__table___UEthdE",
  "wx": "FeatureComparisonTable.module__header___UEthdE",
  "_j": "FeatureComparisonTable.module__headerFeature___UEthdE",
  "t_": "FeatureComparisonTable.module__headerFeatureText___UEthdE",
  "UE": "FeatureComparisonTable.module__headerValues___UEthdE",
  "LX": "FeatureComparisonTable.module__headerRestricted___UEthdE",
  "_b": "FeatureComparisonTable.module__headerStock___UEthdE",
  "Ge": "FeatureComparisonTable.module__rows___UEthdE",
};

module.exports = exports;
